import { fieldLabel, isFieldRequired } from '../utils/dataFields';

/**
 * The visual "this field is required" mark (CIN-6871).
 *
 * aria-hidden because the control itself carries `required` / `aria-required`,
 * so a screen reader announces "required" exactly once — never "star".
 */
export const RequiredMark = ({ htmlFor }) => (
  <span className="required-mark" aria-hidden="true" data-testid={`required-mark-${htmlFor}`}>
    *
  </span>
);

/**
 * A field's <label> plus, for required fields, the asterisk mark.
 *
 * The mark is a SIBLING of <label> inside a `.field-label` wrapper, never a
 * child of it: dom-testing-library computes label text by recursing into child
 * elements and does not honour aria-hidden, so nesting the asterisk would turn
 * the queryable label of "Year" into "Year *" and break exact getByLabelText
 * queries. Real browsers exclude aria-hidden subtrees from the accessible name
 * either way, so a11y is identical.
 *
 * Required-ness comes from `field.required` (via isFieldRequired) — the exact
 * flag Scheduler.js's isStepValid advance gate reads — unless an explicit
 * `required` prop is passed for a field that is implicitly required by a
 * hardcoded gate rather than by calendar config.
 */
const FieldLabel = ({ htmlFor, field, required, children }) => {
  const isRequired = required === undefined ? isFieldRequired(field) : !!required;
  return (
    <span className="field-label">
      <label htmlFor={htmlFor}>{children !== undefined ? children : fieldLabel(field)}</label>
      {isRequired && <RequiredMark htmlFor={htmlFor} />}
    </span>
  );
};

export default FieldLabel;
